import { NgClass } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

import type { DiagnosticKeyword } from ':shared/models/keyword';

import { PartnerThemeContext } from ':core/context/partner-theme.context';
import { SvgIcon } from ':shared/enums';
import { Illustration, IllustrationPathResolverPipe, PositionTranslatePipe } from ':shared/pipes';

@Component({
    selector: 'app-ranking-competitors-list',
    templateUrl: './ranking-competitors-keyword-list.component.html',
    styleUrls: ['./ranking-competitors-keyword-list.component.scss'],
    imports: [MatIconModule, NgClass, TranslateModule, IllustrationPathResolverPipe, PositionTranslatePipe],
})
export class RankingCompetitorsKeywordListComponent {
    readonly SvgIcon = SvgIcon;
    readonly Illustration = Illustration;

    public keyword: string;
    public restaurantsRankingList: DiagnosticKeyword['competitorsGooglePositions'];
    public restaurantIndex: number;

    readonly data = inject<{
        keyword: string;
        restaurantsRankingList: DiagnosticKeyword['competitorsGooglePositions'];
        restaurantIndex: number;
    }>(MAT_DIALOG_DATA);
    private readonly _dialogRef = inject(MatDialogRef<RankingCompetitorsKeywordListComponent>);

    constructor() {
        this.keyword = this.data.keyword;
        this.restaurantsRankingList = this.data.restaurantsRankingList;
        this.restaurantIndex = this.data.restaurantIndex;
    }

    readonly partnerTheme = inject(PartnerThemeContext).activeTheme;

    cancel(done: boolean = false): void {
        this._dialogRef.close(done);
    }

    getEmojiFromPosition = (position: number): string => {
        switch (true) {
            case position === 1:
                return '🏆';
            case position === 2:
                return '🥈';
            case position === 3:
                return '🥉';
            case position <= 10:
                return '💪';
            case position <= 15:
                return '✌️';
            case position <= 20:
                return '🙌';
            default:
                return '😶‍🌫️';
        }
    };
}
